<!--  -->
<template>
  <div>
    <div class="activityList">
      <div
        v-for="(item, index) in activityList"
        :key="index"
        @mouseenter="cardHover(index)"
        @mouseleave="cardHover(index)"
        style="position:relative;"
        @click="router(item.id)"
      >
        <Poptip
          placement="bottom-end"
          class="editIcon"
          trigger="hover"
          width="130"
        >
          <div
            class="iconfont icon-caidan1 card-menu"
            v-if="index == isHoverIndex && isHover"
          ></div>
          <div slot="content">
            <div class="box-v pop-wrapper">
              <div
                :style="{
                  background: changeState == 'chehui' ? '#f1f1f1' : ''
                }"
                @mouseover="change('chehui')"
                @mouseout="change('')"
                v-if="isCaogao != 1"
                @click="backActiveDraft(item.state, item.id)"
              >
                撤回
              </div>
              <div
                :style="{
                  background: changeState == 'shanchu' ? '#f1f1f1' : ''
                }"
                @mouseover="change('shanchu')"
                @mouseout="change('')"
                v-if="isCaogao == 1"
                @click="deleteMe(item)"
              >
                删除
              </div>
            </div>
          </div>
        </Poptip>

        <Card class="card-warpper" :padding="0">
          <div v-if="isCaogao != 1">
            <div
              class="triangle"
              :style="{
                borderTopColor:
                  item.activeFlag == 1
                    ? '#47ba53'
                    : item.activeFlag == 2
                    ? '#a1afb2'
                    : '#ff7b43'
              }"
            ></div>
            <div class="triangle-info">{{ item.cnstate }}</div>
          </div>
          <div style="margin: 20px;">
            <img
              v-if="item.coverPicUrl"
              :src="item.coverPicUrl"
              class="coverimg"
            />
            <div v-else class="zhanwei">暂无封面图</div>
          </div>

          <div class="title1">{{ item.title ? item.title : "暂无标题" }}</div>
          <div class="footer" v-if="isCaogao != 1">
            <div class>
              <span class="iconfont icon-chakan delete-text"></span>
              <span class="number">{{ item.previewNumber }}</span>
            </div>
            <div class>
              <span class="iconfont icon-pinglun3 delete-text"></span>
              <span class="number">{{ item.messageNumber }}</span>
            </div>
          </div>
        </Card>
      </div>
    </div>
    <Modal v-model="chexiao" @on-ok="ok" :mask-closable="false">
      <p style="text-align:center;height:50px;line-height:50px;font-size:20px;">
        确定撤销？
      </p>
    </Modal>
    <Modal v-model="shanchu" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <!--<Icon type="information-circled"></Icon>-->
        <span>删除确认</span>
      </p>
      <div style="text-align:center">
        <p>是否确认删除？</p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          @click="del()"
          :loading="shanchuIng"
          >删除</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    activityList: {
      type: Array,
      default: () => []
    },
    isCaogao: {
      type: Number,
      default: 0
    }
  },
  data() {
    //这里存放数据
    return {
      isHover: false, //卡片是否悬浮
      isHoverIndex: 0,
      changeState: "",
      chexiao: false,
      activityId: "", //撤回用id
      activityState: "",
      shanchu: false,
      shanchuIng: false,
      actid: "" //删除用id
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //卡片悬停显示点点点图标
    cardHover(index) {
      this.isHoverIndex = index;
      this.isHover = !this.isHover;
    },
    change(item) {
      this.changeState = item;
    },
    router(id) {
      if (this.isCaogao == 0) {
        this.$router.push({ name: "activitydetail", query: { id } });
      } else {
        this.$router.push({ name: "newactivity", query: { id } });
      }
    },
    backActiveDraft(num, id) {
      //点击撤销    弹出model
      event.stopPropagation();
      if (num == 1) {
        this.chexiao = true;
      }
      this.activityId = id;
      this.activityState = num;
    },
    ok() {
      var that = this;
      if (this.activityState == 1) {
        var url = this.urlobj.activeDel(this.activityId) + `?isDelete=0`;
        this.$delete(url).then(function(res) {
          that.$emit("init", that.activityState); //1是已发送  0是草稿
        });
      }
    },
    deleteMe(val) {
      console.log(val);
      event.stopPropagation();
      this.shanchu = true;
      this.actid = val.id;
      this.activityState = val.state;
    },
    del() {
      var that = this;
      that.shanchuIng = true;
      var url = this.urlobj.activeDel(this.actid) + `?isDelete=1`;
      this.$delete(url).then(function(res) {
        that.shanchu = false;
        that.shanchuIng = false;
        that.$emit("init", that.activityState); //1是已发送  0是草稿
      });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
.activityList {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(328px, 1fr));
  grid-gap: 20px;

  padding: 20px;
  padding-top: 0;
}
// 卡片样式
.editIcon {
  position: absolute;
  top: 25px;
  right: 30px;
  z-index: 999;
  &:hover {
    cursor: pointer;
  }
}
.card-menu {
  font-size: 25px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.3);
  line-height: 0.8em;
  width: 30px;
  text-align: center;
  border-radius: 30px;
}
.coverimg {
  display: inline-block;
  width: 100%;
  height: 200px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.zhanwei {
  background: #ddd;
  text-align: center;
  height: 200px;
  line-height: 200px;
}
.title1 {
  padding: 0 20px;
  margin-bottom: 20px;
  // box-sizing: content-box;
  color: #4b4b4b;
  font-size: 18px;
  height: 2.4em;
  line-height: 1.2em;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #eee;
  height: 46px;

  .delete-text {
    font-size: 20px;
  }
  .number {
    margin: 0 48px 0 10px;
    color: #666;
    font-size: 15px;
    vertical-align: text-bottom;
  }
}
.pop-wrapper {
  text-align: center;
  letter-spacing: 20px;
  color: #999;
}
.triangle {
  position: absolute;
  top: 20px;
  left: 19px;
  width: 0;
  height: 0;
  border-top: 60px solid #47ba53;
  border-right: 60px solid transparent;
}
.triangle-info {
  position: absolute;
  top: 30px;
  left: 20px;
  color: #fff;
  transform: rotate(-45deg);
}
</style>
